module.exports = __webpack_public_path__ + "images/about-placeholder-3.jpg";